// React

// Material UI
import { Box, Tooltip, IconButton } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';

// Icons
import { CalendarTodayOutlined } from '@mui/icons-material';

// Utils
import { format } from 'date-fns';
import { buildGoogleCalendarLink } from '../../../../../../../utils/googleCalendarUtils';

// Styles
import styles from './Event.module.scss';

const Event = ({ color, event, openModal }) => {
  const themeEvent = createTheme({
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            background: '#7B878E !important',
          },
        },
      },
    },
  });

  const hours = event.allDay
    ? 'all day'
    : `${format(event.startFormatted, 'HH:mm')} - ${format(event.endFormatted, 'HH:mm')}`;

  const handleEventClick = () => {
    openModal();
  };

  const handleCalendarIconClick = (e, event) => {
    e.stopPropagation();
    const link = buildGoogleCalendarLink({
      title: event.title,
      start: event.start,
      end: event.end,
      description: event.description,
      location: event.location,
      rrule: event.rrule,
    });
    window.open(link, '_blank', 'noopener,noreferrer');
  };

  return (
    <Box
      className={styles.container}
      style={{
        cursor: 'pointer',
      }}
      onClick={handleEventClick}
    >
      {event.new && (
        <Box className={styles.container__new}>
          <Box className={styles.container__new__cues}></Box>
        </Box>
      )}
      <Box className={styles.container__left}>
        <Box className={styles.container__left__title}>{event.title}</Box>
        <Box className={styles.container__left__title__hours}>{hours}</Box>
      </Box>
      <Box className={styles.container__right}>
        <ThemeProvider theme={themeEvent}>
          <Tooltip title="Add to your calendar" placement="left">
            <IconButton onClick={(e) => handleCalendarIconClick(e, event)}>
              <CalendarTodayOutlined htmlColor="black"></CalendarTodayOutlined>
            </IconButton>
          </Tooltip>
        </ThemeProvider>
        <Box
          style={{
            backgroundColor: color,
            right: 0,
            height: '76px',
            width: '21px',
            borderRadius: '0px 12px 12px 0px',
          }}
        ></Box>
      </Box>
    </Box>
  );
};

export default Event;
